export default __webpack_public_path__ + "static/media/arrow-down.5169ee5f.svg";